export default [
  {
    headerLabel: 'reports.stores',
    type: 'general',
    field: 'branch',
    className: null,
    render: true,
    fixed: true,
  },
  {
    headerLabel: 'lm_label',
    type: 'general',
    field: 'idProduct',
    className: 'align-right',
    render: true,
    fixed: true,
  },
  {
    headerLabel: 'reports.description',
    type: 'general',
    field: 'dsProduct',
    className: null,
    render: true,
    fixed: true,
  },
  {
    headerLabel: 'section',
    type: 'general',
    field: 'section',
    className: null,
    render: true,
    fixed: true,
  },
  {
    headerLabel: 'stock.origin',
    type: 'general',
    field: 'origin',
    className: null,
    render: true,
    fixed: true,
  },
  {
    headerLabel: 'stock.destiny',
    type: 'general',
    field: 'destiny',
    className: null,
    render: true,
    fixed: true,
  },
  {
    headerLabel: 'stock.quantity',
    type: 'decimal2',
    field: 'quantity',
    className: 'align-right',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'stock.originBefore',
    type: 'decimal2',
    field: 'qtOriginBefore',
    className: 'align-right',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'stock.destinyBefore',
    type: 'decimal2',
    field: 'qtDestinyBefore',
    className: 'align-right',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'stock.originAfter',
    type: 'decimal2',
    field: 'qtOriginAfter',
    className: 'align-right',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'stock.destinyAfter',
    type: 'decimal2',
    field: 'qtDestinyAfter',
    className: 'align-right',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'changePasswordActivity.ldap',
    type: 'general',
    field: 'ldapWithName',
    className: 'align-right',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'stock.dateTransfer.date',
    type: 'date',
    field: 'dtTransfer',
    className: 'align-right',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'stock.dateTransfer.hour',
    type: 'hour',
    field: 'dtTransfer',
    className: 'align-right',
    render: true,
    fixed: false,
  },
]
